import AcceptPhoto from './AcceptPhoto'
export default AcceptPhoto
